// Đổi mật khẩu
export const SET_CHANGE_PASSWORD_STORE = "SET_CHANGE_PASSWORD_STORE";
export const RESET_CHANGE_PASSWORD_STORE = "RESET_CHANGE_PASSWORD_STORE";

export const FETCH_CHANGE_PASSWORD_REQUEST = "FETCH_CHANGE_PASSWORD_REQUEST";
export const FETCH_CHANGE_PASSWORD_SUCCESS = "FETCH_CHANGE_PASSWORD_SUCCESS";
export const FETCH_CHANGE_PASSWORD_FAILURE = "FETCH_CHANGE_PASSWORD_FAILURE";

export const FETCH_CHANGE_PASSWORD_AUTH_REQUEST = "FETCH_CHANGE_PASSWORD_AUTH_REQUEST";
export const FETCH_CHANGE_PASSWORD_AUTH_SUCCESS = "FETCH_CHANGE_PASSWORD_AUTH_SUCCESS";
export const FETCH_CHANGE_PASSWORD_AUTH_FAILURE = "FETCH_CHANGE_PASSWORD_AUTH_FAILURE";